const RECENT_DETECTION_WINDOW_DAYS = 7;

export function isRecentlyDetected(detectedAt: string | null): boolean {
  if (!detectedAt) return false;
  const detected = new Date(detectedAt);
  const windowStart = new Date();
  windowStart.setDate(windowStart.getDate() - RECENT_DETECTION_WINDOW_DAYS);
  return detected > windowStart;
}
